import axios from 'axios';

axios.defaults.headers.put['Content-Type'] = 'application/x-www-form-urlencoded';

const _DEV = 0;
const _TESTE = 1;
const _PROD = 2;

const ambienteDjango = [
  'http://127.0.0.1:8000',
  'https://requisicaoalmoxarifadomanagerhc2.famema.br',
  'https://requisicaoalmoxarifadomanagerhc.famema.br',
];

const ambienteNode = [
  'https://localhost:5434',
  'https://requisicaoalmoxarifadonodehc2.famema.br',
  'https://requisicaoalmoxarifadonodehc.famema.br',
];

export const dominioBackend = axios.create({
  baseURL: ambienteDjango[_PROD],
});

export const dominioLog = axios.create({
  baseURL: ambienteNode[_PROD],
});

dominioBackend.interceptors.request.use(
  config => {
    const profissional = JSON.parse(localStorage.getItem('profissional'));
    if (profissional) {
      config.headers.Authorization = `JWT ${profissional.token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

dominioBackend.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
